export default [
    {
        text: 'Cuenta',
        sortable: false,
        value: 'account',
        width: '31%',
    },
    {
        text: 'Centro de Costo',
        sortable: false,
        value: 'account',
        width: '12%',
    },
    {
        text: 'Documento',
        sortable: false,
        value: 'ref_document',
        width: '10%',
    },
    {
        text: 'Glosa',
        sortable: false,
        value: 'description',
        width: '10%',
    },
    {
        text: 'Debe',
        sortable: false,
        value: 'debt',
        width: '18%',
    },
    {
        text: 'Haber',
        sortable: false,
        value: 'receive',
        width: '18%',
    },
    {
        text: '',
        sortable: false,
        value: '',
        width: '10px',
    },
]
